"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledRadio = void 0;
var _Radio = require("./Radio");
// TODO: in v9, move styled() from Radio.jsx to here
var StyledRadio = _Radio.Radio;
exports.StyledRadio = StyledRadio;